module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};



// WEBPACK FOOTER //
// ./techpad-upgrade/~/core-js/modules/_a-function.js